<template>
  <div>
    <div class="row q-gutter-x-sm">
      <div class="text-h5">Billing</div>
    </div>
    <q-separator class="q-my-md" />
    <all-subscriptions
      v-if="childSubscriptions.length"
      :subscriptions="subscriptions"
      :child-subscriptions="childSubscriptions"
      @refresh-subscriptions="refreshChildSubscriptions"
      @open-billing="openBilling"
      @close-child-account="closeChildAccount"
      @keep-child-account="keepChildAccount"
    />
    <div v-else class="window-height">
      <q-inner-loading showing color="secondary" />
    </div>
  </div>
</template>

<script lang="ts">
import { useStripeStore } from '@/stores/stripe'
import AllSubscriptions from '@/components/Billing/AllSubscriptions.vue'

export default {
  name: 'BillingView',
  components: { AllSubscriptions },
  computed: {
    childSubscriptions() {
      return useStripeStore().childSubscriptions
    },
    subscriptions() {
      return useStripeStore().subscriptions
    }
  },
  created() {
    if (!useStripeStore().childSubscriptions.length) {
      this.refreshChildSubscriptions().then(() => {
        if (!this.childSubscriptions.length) {
          this.openBilling()
        }
      })
    }
  },
  methods: {
    refreshChildSubscriptions() {
      return useStripeStore().initChildSubscriptions()
    },
    async openBilling() {
      const url = await useStripeStore().getCustomerPortal()
      if (url) {
        this.$tracker.pageView('Billing', url)
        window.location.href = url
      }
    },
    async closeChildAccount(subscriptionId: string) {
      await useStripeStore().closeChildAccount(subscriptionId)
    },
    async keepChildAccount(subscriptionId: string) {
      await useStripeStore().keepChildAccount(subscriptionId)
    }
  }
}
</script>
<style scoped>
.modal-title {
  font-size: 20px;
  font-weight: 400;
}
</style>
